import React from 'react';

const UnitTypeTitle = ({ record }) => {
	return <span>UnitType {record ? `"${record.name}"` : ''}</span>;
};

export default UnitTypeTitle;
